import type { OutgoingInvoiceData, ProjectData } from ".";
import { ExpenseStructured, OurWorkStructured } from "./Structured";

export class Project {
  id: ProjectData["id"];
  code: ProjectData["code"];
  title: ProjectData["title"];
  team_name: ProjectData["team"]["name"];

  ourWorkStructured?: OurWorkStructured[];
  expensesStructured?: ExpenseStructured[];

  constructor(
    project: ProjectData,
    ourWorkSplits?: OutgoingInvoiceData["ourWorkBudgetSplits"],
    expenseSplits?: OutgoingInvoiceData["expenseBudgetSplits"],
  ) {
    this.id = project.id;
    this.code = project.code;
    this.title = project.title;
    this.team_name = project.team.name;
    if (ourWorkSplits && expenseSplits) {
      this.ourWorkStructured = project.ourWorkStructured.map(
        (structured) => new OurWorkStructured(structured, ourWorkSplits),
      );
      this.expensesStructured = project.expensesStructured.map(
        (structured) => new ExpenseStructured(structured, expenseSplits),
      );
    }
  }
}
